import ReactSlider from 'react-slider';
import styled from 'styled-components';

import { theme } from '../../theme';

export const InputStyles = {
	border: `1px solid ${theme.colors.input.border.default}`,
	borderRadius: '4px',
	width: '63px',
	height: '40px',
	marginLeft: '16px',
	padding: '8px',
	fontSize: '15px',
	fontFamily: 'ProximaNova-Medium',
	outline: 'none',
};

export const StyledContainer = styled.div`
	max-width: 320px;
	display: flex;
	align-items: center;
`;

export const StyledSlider = styled(ReactSlider)`
	width: 100%;
	max-width: 160px;
	height: 4px;
	display: flex;
	align-items: center;
`;

export const ArrowStyle = {
	cursor: 'pointer',
	content: '',
	width: '6px',
	height: '6px',
	borderRight: `2px solid ${theme.colors.rangeSlider.arrow.color.default}`,
	borderTop: `2px solid ${theme.colors.rangeSlider.arrow.color.default}`,
	marginRight: '0.5em',
	marginLeft: '1.0em',
	borderColor: 'transparent',
	background: 'transparent',
	boxShadow: 'none',
	'&:hover': {
		background: 'transparent',
		borderColor: 'transparent',
		boxShadow: 'none',
	},
};

export const ArrowDownStyle = {
	top: '50%',
	transform: 'rotate(135deg)',
};

export const ArrowUpStyle = {
	top: 'calc(50% - 8px)',
	transform: 'rotate(-45deg)',
};
